// Inline declaration drafts for the admin parcel-create form
// (owner spec 2026-06-01). The full form first POSTs the parcel, then
// loops each draft through ``apiParcelsProductsPost`` — these types
// describe a single in-memory row before it has a parcel_id.

export type ParcelCreateProductDraft = {
  // Stable client-side id so React can key the row across edits / deletes.
  client_id: string;
  category_id: string;
  subcategory_id: string;
  full_name: string;
  // Stored as a string so the input round-trip stays lossless even on
  // partial edits. Cast to ``number`` only at submit time.
  quantity: string;
  price_per_item: string;
};

export const makeEmptyDraft = (): ParcelCreateProductDraft => ({
  client_id: (typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `draft-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`),
  category_id: '',
  subcategory_id: '',
  full_name: '',
  quantity: '1',
  price_per_item: '0',
});

// Validation errors per row, keyed by the field name. Empty means valid.
export type ParcelCreateProductDraftErrors = Partial<
  Record<'category_id' | 'subcategory_id' | 'full_name' | 'quantity' | 'price_per_item', string>
>;
